import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RehabilitationProgramDTO } from '@core/apis/rehabilitation/rehabilitation.dto';
import { DatepickerInputComponent } from '@core/components/datepicker-input/datepicker-input.component';
import { BookingStorageEnum } from '@core/enums/booking.enum';
import { IBookingBasketItem, IBookingStorageDeleteEvent, IFormatTimeData } from '@core/interfaces/booking.interface';
import { IUserStore } from '@core/interfaces/interface';
import { UserStore } from '@core/stores/user.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RehabilitationViewComponent } from '../../rehabilitation-view/rehabilitation-view.component';
import { FormatTimeDataTypeEnum } from '@oranta-mis/sdk';

@Component({
  selector: 'app-rehabilitation-order',
  imports: [TranslocoModule, RehabilitationViewComponent, ReactiveFormsModule, DatepickerInputComponent],
  templateUrl: './rehabilitation-order.component.html',
  styleUrl: './rehabilitation-order.component.scss',
})
@UntilDestroy()
export class RehabilitationOrderComponent {
  public program!: RehabilitationProgramDTO;
  public form!: FormGroup;
  public user: IUserStore | null = null;
  public durationType!: FormatTimeDataTypeEnum;
  public readonly FormatTimeDataTypeEnum = FormatTimeDataTypeEnum;

  @Input() set programValue(p: RehabilitationProgramDTO) {
    if (p) {
      this.program = p;
    }
  }

  @Output() delete: EventEmitter<IBookingStorageDeleteEvent> = new EventEmitter<IBookingStorageDeleteEvent>();
  @Output() formValue: EventEmitter<IBookingBasketItem> = new EventEmitter<IBookingBasketItem>();

  constructor(
    private readonly userStore: UserStore,
    private readonly fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.user = this.userStore.get();
    this.reactiveForm();
    this.formValue.emit({
      type: BookingStorageEnum.rehabilitation,
      form: this.form,
    });
    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((v) => {
      this.formValue.emit({
        type: BookingStorageEnum.rehabilitation,
        form: this.form,
      });
    });

    const user = this.userStore.get();
    if (user) this.form.get('patientId')?.setValue(user.id);

    this.form.get('id')?.setValue(this.program.id);
    let value: IFormatTimeData = this.program.formatTime;
    if (value) {
      this.durationType = value.type;
      if (this.durationType == FormatTimeDataTypeEnum.by_date) this.startDate?.setValue(value.startDate);
    }
  }

  private reactiveForm() {
    this.form = this.fb.group({
      id: [null, Validators.required],
      startDate: [null, Validators.required],
      note: [null],
      patientId: [null, Validators.required],
    });
  }

  public get startDate(): FormControl {
    return this.form.get('startDate') as FormControl;
  }
}
